import { integratedWithLight } from '@/assets/integrations';

function IntegratedWithTitle() {
  return (
    <img
      src={integratedWithLight}
      alt="Integrated with"
      width={202}
      height={26}
      loading="eager"
      {...{ fetchpriority: 'high' }}
      decoding="async"
      className="h-auto w-28 shrink-0 sm:w-[202px]"
    />
  );
}

export default IntegratedWithTitle;
